import React from 'react';

const Ekinmaydon = () => {
    return (
        <div>
            Ekinmaydon
        </div>
    );
};

export default Ekinmaydon;